module.exports = "https://coursera_assets.s3.amazonaws.com/images/d42151303826d417e08e356d2adf8da1.png";